import NextImage from 'next/image'

import generateBlurDataURL from '@/helpers/generateBlurDataURL'
import Motion from '@/organisms/Motion'

function Image(props: PresentationImageProps) {
  const { src, title, onClick } = props
  const blur = generateBlurDataURL(420, 420)

  return (
    <Motion
      as="figure"
      key={src}
      onClick={onClick}
      className="min-w-full cursor-pointer h-[220px] xs:h-[380px] md:h-[428px] relative flex justify-center items-center overflow-hidden"
    >
      <NextImage
        className="max-w-full max-h-full"
        alt={title}
        src={src}
        layout="fill"
        objectFit="contain"
        placeholder="blur"
        blurDataURL={blur}
        quality={75}
      />
    </Motion>
  )
}

interface PresentationImageProps {
  src: string
  title: string
  onClick(): void
}

export default Image
